import React, { memo } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip);

const Sparkline = memo(function Sparkline({ values = [], color = '#3b82f6', height = 34 }) {
    const data = {
        labels: values.map((_, i) => i),
        datasets: [
            {
                data: values.map(v => Number(v) || 0),
                borderColor: color,
                backgroundColor: 'transparent',
                fill: false,
                tension: 0.3,
                pointRadius: 0,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        elements: { line: { borderWidth: 2 } },
        plugins: { legend: { display: false }, tooltip: { enabled: false }, valueLabels: false },
        scales: {
            x: { display: false },
            y: { display: false },
        },
    };

    return (
        // use the css wrapper so CSS controls the exact size instead of an inline fixed width
        <div className="sparkline-wrap" style={{ width: '100%', height }}>
            <Line data={data} options={options} />
        </div>
    );
});

export default Sparkline;